import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

/**
 * Componente para validar se o usuário pertence à empresa do slug
 * Previne acesso cruzado entre empresas
 */
export default function SlugValidator({ children }) {
  const { slug } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Se não tiver slug na URL, permitir (rotas sem slug como /login do Super Admin)
    if (!slug) {
      return;
    }

    // Se não estiver logado, permitir (ProtectedRoute vai redirecionar)
    if (!user) {
      return;
    }

    // Super Admin pode acessar qualquer empresa
    const isSuperAdmin = user.roles?.some(role => role.type === 'SUPER_ADMIN');
    if (isSuperAdmin) {
      return;
    }

    // Validar se o usuário pertence à empresa do slug
    const userCompanySlug = user.company?.layout?.slug;

    if (!userCompanySlug) {
      toast.error('Empresa não configurada');
      navigate('/login', { replace: true });
      return;
    }

    // Se o slug da URL não corresponder ao slug da empresa do usuário
    if (slug !== userCompanySlug) {
      toast.error('Você não tem permissão para acessar esta empresa');
      // Redirecionar para a empresa correta do usuário, mantendo o path
      const pathParts = window.location.pathname.split('/').filter(p => p);
      const currentPath = pathParts.slice(1).join('/'); // Remove primeiro segmento (slug inválido)
      const targetPath = currentPath ? `/${userCompanySlug}/${currentPath}` : `/${userCompanySlug}/dashboard`;
      navigate(targetPath, { replace: true });
      return;
    }
  }, [slug, user, navigate]);

  return children;
}
